import { FormProvider } from 'react-hook-form';
import { Button, Stack } from '@chakra-ui/react';

import { Dialog, FormField, Select } from '~/core/shared/components';
import {
  useGrantorOptions,
  useGrantorSearchForm,
  useGrantorSearchModalApi,
} from './hooks';

export const EquifaxPpsrGrantorSearchModal = () => {
  const modalApi = useGrantorSearchModalApi();
  const grantorOptions = useGrantorOptions(modalApi);
  const { form, isLoading, onSubmit } = useGrantorSearchForm(modalApi);

  return (
    <Dialog
      header="Equifax - PPSR Grantor Search"
      onOpenChange={modalApi.onOpenChange}
      open={modalApi.open}
      size="md"
    >
      <FormProvider {...form}>
        <Stack as="form" gap={4} onSubmit={form.handleSubmit(onSubmit)} p={6}>
          <FormField
            component={Select}
            label="Grantor"
            name="grantorId"
            options={grantorOptions}
            placeholder="Select Grantor"
            required
          />

          <Stack direction="row" justifyContent="end">
            <Button
              colorPalette="gray"
              fontSize="md"
              fontWeight="normal"
              onClick={modalApi.onClose}
              variant="outline"
            >
              Cancel
            </Button>
            <Button
              colorPalette="primary"
              disabled={!form.watch('grantorId')}
              fontSize="md"
              fontWeight="bold"
              loading={isLoading}
              type="submit"
              variant="solid"
            >
              Run Search
            </Button>
          </Stack>
        </Stack>
      </FormProvider>
    </Dialog>
  );
};
